/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 *  Object properties described in a parent class as @State are reactive and accessible from Vue.$store
 */
import Vue from 'vue';

type Handler = {
	get: () => BaseModule;
	set: (value: BaseModule) => boolean;
};

export function createProxy(target: any, handler: ProxyHandler<any>): () => any {
	return new Proxy(target, handler);
}

export function createHandler(module: BaseModule): Handler {
	return {
		get(): BaseModule {
			return module;
		},
		set(value): boolean {
			return module.updateState(value);
		}
	};
}

export class BaseModule {
	private proxyHandlers = new Map();
	private readonly proxyFunctions: Map<string, Common.FnAny> = new Map();

	public createProxyHandler(module: BaseModule, methodName: string, handler: ProxyHandler<any>): any {
		this.proxyHandlers.set(methodName, handler);

		Object.defineProperty(module, methodName, {
			set: (origFunc: any): void => {
				this.proxyFunctions.set(methodName, createProxy(origFunc, this.proxyHandlers.get(methodName)));
			},
			get: (): any => this.proxyFunctions.get(methodName)
		});
	}

	public updateState(value: BaseModule): boolean {
		try {
			Object.keys(value).forEach((key) => {
				Vue.set(this, key, value[key as keyof BaseModule]);
			});
			return true;
		} catch (e) {
			return false;
		}
	}
}
